import { ICellRendererParams } from "ag-grid-community";
import { Avatar, Box, Stack, Typography } from "@mui/joy";
import ReactRouterLink from "@/components/ReactRouterLink/ReactRouterLink";
import { AgentObj } from "@/types/interfaces/agents";
import isTtandBranded from "@/utils/isTtandBranded";
import CopyButton from "../../profile/components/CopyButton";
import { getStatusColor } from "./utils";

const initials = (agent?: AgentObj) =>
  [agent?.firstname?.[0], agent?.lastname?.[0]].filter(Boolean).join("").toUpperCase() || "?";

// The agent as a user list shows a person: avatar (in their status colour), name, then their TTAND handle and the brand
// they trade under when it isn't TTAND's own
export const AgentCellRenderer = ({ data }: ICellRendererParams<AgentObj>) => {
  const handle = data?.ttandEmail?.split("@")[0];
  const brand = data?.brandedAs && !isTtandBranded(data.brandedAs) ? data.brandedAs : undefined;
  const secondary = [handle, brand].filter(Boolean).join(" · ");

  return (
    <Stack direction="row" alignItems="center" gap={1.25} sx={{ minWidth: 0, height: "100%" }}>
      <Avatar size="sm" variant="soft" color={getStatusColor(data)} sx={{ fontSize: "xs", fontWeight: "lg" }}>
        {initials(data)}
      </Avatar>
      <Stack sx={{ minWidth: 0, lineHeight: 1.3, flex: 1 }}>
        <Typography
          component={ReactRouterLink}
          noWrap
          textColor="text.primary"
          to={`/admin/agents/profile?email=${encodeURIComponent(data?.ttandEmail || "")}`}
          fontWeight="lg"
          sx={{ fontSize: "inherit", "&:hover": { color: "primary.plainColor", textDecoration: "underline" } }}
        >
          {data?.name}
        </Typography>
        {secondary && (
          <Typography noWrap level="body-xs" textColor="text.tertiary" title={secondary}>
            {secondary}
          </Typography>
        )}
      </Stack>
      {/* The full TTAND address in one click; the cell itself only shows the handle */}
      {data?.ttandEmail && (
        <Box className="copy-on-hover" sx={{ flexShrink: 0 }}>
          <CopyButton value={data.ttandEmail} label={`Copy ${data.ttandEmail}`} />
        </Box>
      )}
    </Stack>
  );
};
